import { defineStyleConfig } from '@chakra-ui/react';

export const Heading = defineStyleConfig({
  baseStyle: {
    color: 'text.default',
    fontWeight: '500',
    lineHeight: '1.5',
  },
});
